import React from 'react';
import {
    Typography
} from "@mui/material";
import {parseISO} from 'date-fns';
import {RRuleHelper} from "../../../../utils/RRuleHelper";
import Grid from "@mui/material/Grid2";


function CampaignSummary({...props}) {
    const {values} = props;
	const patrimoine = values.patrimoine;

    const getFormattedDate = (date) => {
        return parseISO(date).toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    }

    return (
        <Grid container size={12} spacing={1} className={"sectionContainer"}>
            <Grid size={12}>
                <Typography variant={"h5"} className={"sectionHeader"}>Récapitulatif</Typography>
            </Grid>

            {/*LIBELLE FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    <Typography>Libellé</Typography>
                </Grid>
                <Grid size={9}>
                    <Typography>{values.libelle}</Typography>
                </Grid>
            </Grid>
            {/*DATE FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    <Typography>Date</Typography>
                </Grid>
                <Grid size={9}>
                    {/*<Typography>{format(parseISO(values.dateDebut), 'dd/MM/yyyy')} au {format(parseISO(values.dateFin), 'dd/MM/yyyy')}</Typography>*/}
                    <Typography>Démarrage le {getFormattedDate(values.dateDebut)}</Typography>
                    <Typography>Heure de début : {values.heureDebut ? String(values.heureDebut).slice(0, 5) : 'non renseignée'}</Typography>
                    <Typography>{RRuleHelper.rruleToText(values.rrule)}</Typography>
                </Grid>
            </Grid>
            {/*PRESTATION FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    <Typography>Prestation</Typography>
                </Grid>
                <Grid size={9}>
                    <Typography>{values.prestation.libelle}</Typography>
                </Grid>
            </Grid>
            {/*CLIENT FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    <Typography>Client</Typography>
                </Grid>
                <Grid size={9}>
                    <Typography>{values.client.libelle ?? values.client.email}</Typography>
                </Grid>
            </Grid>
            {/*FORMULAIRE FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    <Typography>Formulaire</Typography>
                </Grid>
                <Grid size={9}>
                    <Typography>{values.formulaire.libelle}</Typography>
                </Grid>
            </Grid>
            {/*PATRIMOINE FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    <Typography>Patrimoine</Typography>
                </Grid>
                <Grid size={9}>
                    <Typography>{patrimoine?.libelle ?? 'Patrimoine sélectionné'}</Typography>
                </Grid>
            </Grid>
            {/*CONTENEURS FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    <Typography>Nombre de conteneurs</Typography>
                </Grid>
                <Grid size={9}>
                    <Typography>{patrimoine?.isUnipatrimoine ? patrimoine.nombreDeBacs + " bacs" : values.conteneurs?.length ?? 0}</Typography>
                </Grid>
            </Grid>
            {/*CONTENEURS FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    <Typography>Chauffeur</Typography>
                </Grid>
                <Grid size={9}>
                    {values.chauffeur?.libelle}
                </Grid>
            </Grid>
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    <Typography>Equipier</Typography>
                </Grid>
                <Grid size={9}>
                    {values.equipier?.libelle ?? "Pas d'équipier"}
                </Grid>
            </Grid>


        </Grid>
    );
}

export default CampaignSummary;
